import React, { useState, useEffect } from "react";
import ModalWrapper from "../../../modal/ModelWrapper";
import { capitalizeFirstLetter, formatDuration } from "../../../../utils/utils";
import videos from "../../../../services/videos";
import Vimeo from "@u-wave/react-vimeo";
import { CustomButton } from "../../physician_page/styled";
import { LuCircleCheckBig } from "react-icons/lu";
import { FiClock } from "react-icons/fi";
import journeyService from "../../../../services/journey";
import { notify } from "../../../../utils/helper";

const ViewVideoModal = ({ isOpen, setOpen, videoData, journeyData, fetchAssignment, onSuccess, templateView, isPublicRoute }) => {
  const [videIframe, setVideoIframe] = useState(null);
  const [isError, setIsError] = useState(false);
  const [isCompleting, setIsCompleting] = useState(false);
  const [isFeedbackModal, setIsFeedbackModal] = useState(false);

  const getVideoUrl = async () => {
    try {
      if (isPublicRoute) {
        const res = await videos.getPublicVideoById({ url: videoData?.video?.videoUrl });
        setVideoIframe(res?.data?.video);
      } else {
        const res = await videos.getVideoById({
          url: videoData?.video?.videoUrl,
        });
        setVideoIframe(res?.data?.video);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (videoData) {
      getVideoUrl();
    }
  }, [videoData]);

  const completeStep = async (videoData, journeyData) => {
    if (isCompleting) return; // prevent double call

    setIsCompleting(true);
    const assignId = journeyData?.id || journeyData?._id;
    try {
      const res = journeyService.markWatched(
        assignId,
        {
          videoId: videoData?.video?.id || videoData?.video?._id,
          stepIndex: videoData?.order,
        }
      )
      setOpen(false);
      notify("success", "Video marked as watched");
      fetchAssignment();
      onSuccess();
    } catch (error) {
      setIsCompleting(false);
    }
  };

  const videoSteps = journeyData?.steps?.find((s) => (s.video?._id || s.video?.id) === (videoData?.video?._id || videoData?.video?.id));
  const isWatched = videoSteps?.status === "watched";

  return (
    <>
      <ModalWrapper
        show={isOpen}
        setShow={setOpen}
        title={
          <div className="d-flex flex-column w-100">
            <div
              className="font-18 font-semibold text-primary ellipsis"
              style={{ width: "95%" }}
            >
              <span>{videoData?.video?.title}</span>
            </div>
            <p
              className="font-14 text-primary ellipsis"
              style={{ width: "95%", margin: "2px 0 0 0", color: "#64748b" }}
            >
              {capitalizeFirstLetter(videoData?.video?.description)}
            </p>
          </div>
        }
        footer={null}
        width={700}
        centered
      >
        {videIframe ? (
          <>
            <div
              style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
            >
              {isError ? (
                <div>Video is prepraing</div>
              ) : (
                <Vimeo
                  video={videIframe?.player_embed_url}
                  autoplay={false}
                  showTitle={false}
                  showByline={false}
                  showPortrait={false}
                  responsive={true}
                  onError={(error) => setIsError(true)}
                  onEnd={() => !isWatched && completeStep(videoData, journeyData)}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                />
              )}
            </div>

            <div className="d-flex justify-between mt-16">
              <div className="d-flex" style={{ gap: "5px" }}>
                <span className="d-flex" style={{ gap: "5px" }}>
                  <FiClock />
                  Duration:
                </span>
                <span>{formatDuration(videIframe?.duration)}</span>
              </div>
              {(!isWatched && !templateView && !isPublicRoute) && (
                <CustomButton
                  onClick={() => completeStep(videoData, journeyData)}
                  disabled={isCompleting}
                >
                  <LuCircleCheckBig />
                  Mark as Complete
                </CustomButton>
              )}
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center", padding: "40px" }}>
            {/* Invalid video URL */}
            Fetching Video ...
          </div>
        )}
      </ModalWrapper>
    </>
  );
};

export default ViewVideoModal;
